import type { StagedProcessAttachment } from './ProcessAttachmentField';

export function buildProcessRequestFormData(
  formData: Record<string, unknown>,
  stagedAttachments: Record<string, StagedProcessAttachment>,
): Record<string, unknown> {
  const attachment_ids_by_field = Object.fromEntries(
    Object.entries(stagedAttachments).map(([fieldId, attachment]) => [fieldId, attachment.id]),
  );
  return { ...formData, ...attachment_ids_by_field };
}
